/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Import_Csvformat1Inputs */



/**
* | output |
* | --- |
* | "Required format with columns: name, deviceId, objectType, objectInstance, isEnabled, rule.operator, rule.value" |
*
* @param {Alarms_Import_Csvformat1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_import_csvformat1 = /** @type {((inputs?: Alarms_Import_Csvformat1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Import_Csvformat1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Required format with columns: name, deviceId, objectType, objectInstance, isEnabled, rule.operator, rule.value")
	return /** @type {LocalizedString} */ ("Format requis avec les colonnes : name, deviceId, objectType, objectInstance, isEnabled, rule.operator, rule.value")
});
export { alarms_import_csvformat1 as "alarms_import_csvFormat" }